import { Pipe, PipeTransform } from '@angular/core';
import { Environment } from 'src/app/env';

@Pipe({
  name: 'kycImageResource'
})
export class KycImageResourcePipe implements PipeTransform {

  transform(value: string): string {
    return Environment.BASE + '/kyc/resources/' + value;
  }

}
